/* eslint-disable @typescript-eslint/no-namespace */
import { queryOptions } from '@tanstack/react-query'
import axios, { AxiosResponse } from 'axios'
import config from '../config'

export declare namespace NStatus {
  namespace NGetMessages {
    type IResponse = {
      error_message: string
      data: {
        id: number
        sv: string
        en: string
        display_in_app: boolean
      }[]
    }
  }
}

export const getStatusMessages = (): Promise<
  AxiosResponse<NStatus.NGetMessages.IResponse>
> => {
  return axios.get<NStatus.NGetMessages.IResponse>(
    'https://status.boappa.se/api/v1/messages'
  )
}

export const statusQueries = {
  getStatusMessages: () =>
    queryOptions({
      queryKey: [{ scope: 'status', entity: 'getStatusMessage' }],
      queryFn: async () => {
        return (await getStatusMessages()).data.data
      },
      enabled: !config.DISABLE_STATUS_API,
    }),
}
